import { render } from "./Pagination.vue?vue&type=template&id=bd2c81f8&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=bd2c81f8&scoped=true&lang=css"
import "@/styles/common.css?vue&type=style&index=1&id=bd2c81f8&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2c81f8"]])

export default __exports__